var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.lang === 'en' && 'en-app',
    ((_vm.pathName && _vm.pathName.split('/')[1]) || 'home') + '-page',
  ],attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShowLoading),expression:"!isShowLoading"}],staticClass:"main"},[_c('NavBar'),_c('router-view')],1),_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowLoading),expression:"isShowLoading"}]}),_c('Toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }